import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'auctionIcon' })
export class AuctionIconPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param {string} auctionType
   * @returns {string}
   */
  transform(auctionType: string): string {

    let icon = 'gavel';

    switch (auctionType) {
      case 'INVALID':
        icon = 'block';
        break;
      case 'PENDING_DEBTOR_VALIDATION':
        icon = 'help';
        break;
      case 'ACTIVE':
        icon = 'settings';
        break;
      case 'SOLD_ACTIVE':
        icon = 'euro_symbol';
        break;
      case 'SOLD_ARCHIVED':
        icon = 'done';
        break;
      case 'READY':
        icon = 'watch_later';
        break;
      case 'PENDING_INVOICE_VALIDATION':
        icon = 'list';
        break;
      case 'EXPIRED':
        icon = 'highlight_off';
        break;
    }

    return icon;
  }
}
